// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dFgv","content":"styles_content__mBNXL"};